<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="学员故事">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="name"
              placeholder="search by name"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveStudent' }">新增学员故事</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listStudent"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="enterpriseLogo" slot-scope="props">
            <img :src="props.rowData.enterpriseLogo" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateStudent/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除学员"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import studentApi from '../../api/student'

export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      students: [],
      name: '',
      loading: true,
      pageSize: 1000,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          width: '60px',
        }, {
          name: 'name',
          title: '学员姓名',
          width: '10%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: '__slot:enterpriseLogo',
          width: '60px',
        }, {
          name: 'enterprise',
          title: '企业名称',
          width: '15%',
        },
        {
          name: 'school',
          title: '学校',
          width: '10%',
        },
        {
          name: 'job',
          title: '工作',
          width: '15%',
        },
        {
          name: 'shortDescription',
          title: '简单描述',
          width: '30%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    filteredData () {
      if (!this.name || this.name.length < 1) {
        return this.students
      }
      return this.students.filter(item => {
        return item.name.toLowerCase().startsWith(this.name.toLowerCase())
      })
    },
  },
  created () {
    this.listStudent()
  },
  methods: {
    listStudent (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      studentApi.listStudent(params).then(response => {
        this.students = response.students
        this.totalPages = response.totalPage
        this.loading = false
      }).catch(error => alert(error))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      studentApi.deleteStudent(this.deleteId).then(response => {
        if (response.success === true) {
          this.listStudent()
        }
      }).catch(error => alert(error))
    },
    search: debounce(function (name) {
      this.name = name
    }, 400),
    updateSortNum: function (params) {
      studentApi.updateStudent(params.id, params).then(response => {
        if (response.success === true) {
          this.listStudent()
          console.log(typeof params.sortNum)
        }
      }).catch(error => alert(error))
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
